import React from 'react';

import { getLangValue } from '../../../utils/Generic';

const taxText = (hotel, lang) => getLangValue(hotel, lang, 'special_tax_text');

const HotelTax = ({ hotel, lang, special_tax_text = null }) => {
  if (special_tax_text == null) {
    return (
    /* eslint-disable react/no-danger */
    <div
            className='hotel-ecotax'
            dangerouslySetInnerHTML={{ __html: taxText(hotel, lang) }}
    />
    /* eslint-enable react/no-danger */
    );
  }
  return (
    /* eslint-disable react/no-danger */
    <div
            className='hotel-ecotax'
            dangerouslySetInnerHTML={{ __html: special_tax_text }}
    />
    /* eslint-enable react/no-danger */
  );
};

export default HotelTax;
